import React, { useMemo } from 'react';
import { STATE_OPTIONS } from './helpers';
import { CustomMenuItem, CustomSelect } from './UI-CHAKRA/Select/CustomSelect';
import { FormLabel } from './UI-CHAKRA/FormLabel';

interface SelectStateProps {
  value: string;
  onChange(val: string): void;
  onBlur?(event: React.FocusEvent<HTMLElement>): void;
  name?: string;
  error?: boolean;
  disabled?: boolean;
  required?: boolean;
  hideLabel?: boolean;
}

function SelectState(props: SelectStateProps) {
  const { value, onChange, error, disabled, required, hideLabel } = props;

  const menuItems = useMemo(() => {
    return STATE_OPTIONS.map((state, index) => {
      return (
        <CustomMenuItem
          onClick={(value) => {
            onChange(String(value));
          }}
          value={state}
          label={state}
          key={index}
        />
      );
    });
  }, [onChange]);

  const label = useMemo(() => {
    return `Estado${required ? '*' : ''}`;
  }, [required]);

  return (
    <>
      {!hideLabel && <FormLabel>{label}</FormLabel>}
      <CustomSelect
        placeholder={'Selecione um estado'}
        value={value}
        isDisabled={disabled}
        error={error}
        onBlur={props.onBlur}
      >
        {menuItems}
      </CustomSelect>
    </>
  );
}

export default React.memo(SelectState);
